module.exports = __webpack_public_path__ + "img/member_trading_record_icon_431008.89b8b8f9.png";